import {SET_SNACK_BAR_DATA} from './actionTypes';

export const setSnackBarData = (data) => (
	{
		type: SET_SNACK_BAR_DATA,
		payload: data
	}
);
